'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dPartial$002dFunction$0024 from "./scala.-Partial-Function$.js";
var $p;
/** @constructor */
function $c_sr_AbstractPartialFunction() {
}
export { $c_sr_AbstractPartialFunction as $c_sr_AbstractPartialFunction };
$p = $c_sr_AbstractPartialFunction.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
}
export { $h_sr_AbstractPartialFunction as $h_sr_AbstractPartialFunction };
$h_sr_AbstractPartialFunction.prototype = $p;
$p.b = (function() {
  return "<function1>";
});
$p.j = (function(x) {
  return this.cr(x, $j_scala$002e$002dPartial$002dFunction$0024.$m_s_PartialFunction$().gb);
});
$p.cq = (function(x) {
  this.cr(x, $j_scala$002e$002dPartial$002dFunction$0024.$m_s_PartialFunction$().gb);
});
